module.exports = __webpack_public_path__ + "img/dash-circle.5b32f225.svg";